<script>
import { merchantComputed, authComputed } from '@state/helpers'

export default {
  components: {
  },
  inject: ['routerType'],
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    categoryIndex: {
      type: Number,
      default: 0
    },
    categoryId: {
      type: Number,
      default: 0
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
    templateType: {
      type: String,
      required: true,
    },
    tagList: {
      type: Array,
      default: () => [],
    },
    parentTagIndex: {
      type: Array,  
      default: () => [],
    },
    /**
     * @description 是否是美容服務
     */
    isService: {
      type: Boolean,
      require: false
    }
  },
  data() {

    return {
      canSetPrice: false,
      localParentTagIndex: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      tryingToStore: false,
      tryingToRemove: false,
      radioDayCareAdditionType: '1',
      radioServiceType: '1'
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    parentCategoryIndex: {
      get() {
        return this.categoryIndex
      },
      set(value) {
        this.$emit('update:categoryIndex', value)
      },
    },
    parentCategoryId: {
      get() {
        return this.categoryId
      },
      set(value) {
        this.$emit('update:categoryId', value)
      },
    },
    computedParentTagIndex: {
      get() {
        return this.localParentTagIndex;
      },
      set(value) {
        this.localParentTagIndex = value;
        this.$emit('update:parentTagIndex', value);  // 發送事件更新父組件的值
      }
    },
    productBaseBookingUrl() {
      let url = ''
      if (window.globalData.APP_ENV === 'local') {
        url = this.merchantUrl
      } else {
        const prefixUrl = this.merchantUrl.split('//', 2)
        url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
      }
      return url
    },
    serviceBaseUrl() {
      if (this.$hasHomeService()) {
        return `${this.productBaseBookingUrl}/store/分店別名/reservation/服務網址別名＋系統產生數字`
      } else {
        return `${this.productBaseBookingUrl}/reservation/服務網址別名＋系統產生數字`
      }
    },
    submitRules() {
      return {
        alias: [
          {
            required: true,
            message: '請填寫別名',
            trigger: 'blur',
          },
          {
            pattern: /^[a-zA-Z0-9-]+$/,
            message: '請使用英文大小寫字母、數字或英文半形連字號組合',
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: '請填寫服務名稱',
            trigger: 'blur',
          },
        ],
        description: [
          {
            required: true,
            message: '請填寫服務內容',
            trigger: 'blur',
          },
        ],
        feature: [
          {
            required: true,
            message: '請填寫服務內容',
            trigger: 'blur',
          },
        ],
      }
    },
    availableAmount() {
      const amount = this.submitData.inventory - this.defaultValue.qty
      return amount < 0 ? 0 : amount
    },
    isEditMode() {
      return this.defaultValue.id
    },
    introtextOption() {
      const options = []
      this.category.forEach((item) => {
        if (this.submitData.categoryIds === item.id) options.push(...item.params)
      })
      return options
    },
    currentProductAlias() {
      let alias = ''
      this.products.some((item) => item.id === this.submitData.productId && (alias = item.alias))
      return alias
    },
    /**
     * @description 如果不是安親的加購模式才出現
     */
    notServiceAddition() {
      return this.$route.params.type !== 'addition'
    },
    currentCategory() {
      return this.category.filter(item => {
        return item.children.length > 0
      })
    }
  },
  watch: {
    parentCategoryId() {
      this.getParentCategoryIndex()
    },
  },
  created() {
    this.checkCanSetPrice()
    this.getParentCategoryIndex()
    this.localParentTagIndex = this.parentTagIndex.length ? this.parentTagIndex : this.submitData.tagIds;
    if (!this.isEditMode) {
      this.parentCategoryId = this.category[0].id
    } 
  },
  methods: {
    emitSubmitData(){

    },
    async checkCanSetPrice() {
      if (!this.$can('api', 'setPrice')) {
        const merchantInfo = this.currentMerchant
        if (merchantInfo === '' || merchantInfo.cashflowSetting !== 1) {
          const settings = await this.$store.dispatch('merchant/fetchSingle')
          this.canSetPrice = settings.cashflowSetting === 1
          return
        }
      }

      this.canSetPrice = this.$can('api', 'setPrice')
    },
    onChangeCategory() {
      this.$nextTick(function () {
        this.submitData.categoryIds = []
      })
    },
    getParentCategoryIndex() {
      this.category.forEach((item, index) => {
        if (this.parentCategoryId === item.id) {
          this.parentCategoryIndex = index
        }
      })
    },
    validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>

<template>
  <div :class="$style.content">
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating">
      <template v-if="templateType === 'tempService'">
        <el-row :gutter="20">
          <el-col :sm="12" :span="24">
            <el-form-item label="名稱" prop="title" data-tour-step="1" data-tour-text="給此方案一個名稱，讓客戶可以了解不同方案的差異性。">
              <el-input v-model="submitData.title" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="24">
            <el-form-item :label="`${$t('reserve.PET_TO_EMPTY')}類別`" :class="$style.petCategory">
              <el-select v-model="parentCategoryId" :disabled="!!isEditMode" @change="onChangeCategory" class="is-border">
                <el-option v-for="(item, index) in currentCategory" :key="`category-${index}`" :label="item.title"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="服務分類">
              <el-select v-model="computedParentTagIndex" multiple placeholder="選擇標籤">
                <el-option v-for="(tag, index) in tagList" :key="index" :label="tag.title" :value="tag.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="服務抽成設定" required :class="$style.formItemHeight">
              <el-radio-group v-model="submitData.commission_type" :class="$style.radioWidth">
                <el-radio label="fixed">指定金額</el-radio>
                <el-radio label="%">依比例</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="項目描述" prop="description">
              <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" placeholder="請輸入內容" />
            </el-form-item>
          </el-col>
          <el-col v-if="isService" :span="24">
            <el-form-item label="預約內容" prop="content">
              <el-input v-model="submitData.content" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" placeholder="請輸入內容" />
            </el-form-item>
          </el-col>
          <el-col v-if="isService" :span="24">
            <el-form-item label="注意事項" prop="notice">
              <el-input v-model="submitData.notice" placeholder="請輸入內容" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-if="templateType === 'tempSpa'" :class="$style.tempSpa">
        <el-row :gutter="20" :class="$style['tempSpa__switch']">
          <el-col :span="20">
            <h3 :class="$style.fontSize">是否開放此{{ $t('service.SPA') }}服務</h3>
          </el-col>
          <el-col :span="4" :class="$style['tempSpa__switch__main']">
            <el-switch v-model="submitData.state" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"
              change="changeFrontDesk"></el-switch>
          </el-col>
        </el-row>
        <div class="only-bottom-line"></div>
        <el-row :gutter="20" :class="$style['tempSpa__content']">
          <el-col :sm="24" :span="24">
            <el-form-item label="名稱" prop="title" data-tour-step="1">
              <el-input v-model="submitData.title" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :span="24">
            <el-form-item label="主打功能" prop="feature" data-tour-step="1" data-tour-text="給此方案主打功能，讓客戶可以了解不同主打功能的差異性。">
              <el-input v-model="submitData.feature" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <el-col :sm="24" :span="24">
            <el-form-item :label="`關於${$t('service.SPA')}介紹`" prop="description">
              <el-input v-model="submitData.description" placeholder="請輸入內容" type="textarea" :autosize="{ minRows: 6 }"
                class="bg-white is-border is-rounded" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-if="templateType === 'tempDaycare'">
        <el-row :gutter="20" type="flex" justify="space-between" :class="$style['basicSetForm_rowHeight']">
          <el-col :span="19">
            <h3 :class="$style.fontSize">是否開放前台加購</h3>
          </el-col>
          <el-col :span="5">
            <el-switch v-model="submitData.canOverScheduleDetailTime" active-text="是" inactive-text="否" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <div class="only-bottom-line"></div>
        <el-row :gutter="20">
          <el-col :sm="12" :span="24">
            <el-form-item label="名稱" prop="title" data-tour-step="1" data-tour-text="給此方案一個名稱，讓客戶可以了解不同方案的差異性。">
              <el-input v-model="submitData.title" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="24">
            <el-form-item :label="`${$t('reserve.CLIENT')}類別`" :class="$style.petCategory">
              <el-select v-model="parentCategoryId" :disabled="!!isEditMode" @change="onChangeCategory" class="is-border">
                <el-option v-for="(item, index) in currentCategory" :key="`category-${index}`" :label="item.title"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="notServiceAddition">
            <el-form-item label="副標題">
              <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" placeholder="請輸入內容" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="12" v-if="notServiceAddition">
            <el-form-item label="服務類型" class="is-border is-padding is-round">
              <el-radio v-model="radioServiceType" label="1">初次預約才需填寫</el-radio>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="12" v-if="notServiceAddition">
            <el-form-item class="is-border is-padding is-round is-empty-label">
              <span slot="label"> &nbsp </span>
              <el-radio v-model="radioServiceType" label="2">每次預約需填寫</el-radio>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="12" v-if="!notServiceAddition">
            <el-form-item label="服務類型" class="is-border is-padding is-round">
              <el-radio v-model="radioDayCareAdditionType" label="1">到店服務</el-radio>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :span="12" v-if="!notServiceAddition">
            <el-form-item class="is-border is-padding is-round is-empty-label">
              <span slot="label"> &nbsp </span>
              <el-radio v-model="radioDayCareAdditionType" label="2">到府服務</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="最低服務時數">
              <el-input v-model.number="submitData.discount" min="0" type="number">
                <template v-slot:append>分鐘</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="項目描述" prop="description">
              <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" placeholder="請輸入內容" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="入住須知" prop="description">
              <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 4 }"
                class="bg-white is-border is-rounded" placeholder="請輸入內容" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

    </el-form>
  </div>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.formItemHeight {
  // height: 46px;
}

.radioWidth {
  width: 100%;
  display: flex;

  :global {
    .el-radio {
      width: 50%;
      height: 50px;
      display: flex;
      align-items: center;
      border: 1px solid $color-line-dark;
      border-radius: $border-radius;
      padding-left: 10px;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid $color-border-lighter;

  h4 {
    display: inline-block;
  }

  &__title {
    display: inline-flex;
    flex: 1;
    align-items: center;
  }
}

.content {
  background-color: white;
  padding: 15px 20px;
}

.switcher {
  margin-right: 10px;
}

.footer {
  padding-bottom: 15px;
  // text-align: right;
  // border-bottom: 2px solid $color-border-lighter;
}

.form-item {
  &--split {
    :global {
      .el-form-item__content {
        display: flex;
        align-items: center;
      }

      .el-form-item+.el-form-item {
        margin-left: 10px;
      }
    }
  }

  &--separator {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}

.price-qty {
  :global {
    .el-input-group__append {
      border: none;
      background-color: $color-line;
      color: #2f8d96;
    }
  }
}

.tempSpa {
  &__switch {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;

    &__main {
      display: flex;
      justify-content: flex-end;
    }
  }

  &__content {
    margin-top: 10px;
  }
}
</style>
<!-- 封存template
<template>
  <el-col :sm="12" :span="24">
    <el-form-item label="原價" prop="basePrice">
      <el-tooltip :disabled="canSetPrice" effect="dark" content="申請金流並開通後即可編輯價格" placement="top">
        <el-input v-model.number="submitData.basePrice" :disabled="!canSetPrice" min="0" />
      </el-tooltip>
    </el-form-item>
  </el-col>
  <el-col :sm="12" :span="24">
    <el-form-item label="售價" prop="price">
      <el-input v-model.number="submitData.price" :disabled="!canSetPrice" min="0" />
    </el-form-item>
  </el-col>
  <el-col :span="24">
    <el-form-item label="服務項目圖片（圖檔最大 2 MB，檔案格式限 JPG 或 PNG，圖片比例：16：9，建議尺寸：800*450px）">
      <el-alert title="第一張圖片將會是服務項目首圖" type="warning" show-icon style="padding: 0 16px; margin-top: 5px"> </el-alert>
      <ImageUpload v-model="submitData.images" :class="$style.upload" :show-upload="true" :resource="'product'">
      </ImageUpload>
    </el-form-item>
  </el-col>
  <el-col :span="24">
    <el-form-item :label="`服務網址別名`" prop="alias">
      <el-input v-model="submitData.alias" placeholder="請使用英文字母與數字組合" class="bg-white is-border is-rounded" />
    </el-form-item>
  </el-col>
  <el-col style="margin-bottom:20px;font-size: 12px; color: darkgray;" :span="24">
    服務項目網址範例：{{ `${serviceBaseUrl}` }}
  </el-col>
  <el-col :sm="12" :span="24">
    <el-form-item label="寵物體型" prop="categoryIds">
      <el-select v-model="submitData.categoryIds[0]" placeholder="寵物體型">
        <template v-if="parentCategoryId">
          <el-option v-for="(item, index) in category[parentCategoryIndex].children" :key="index" :label="item.title"
            :value="item.id"></el-option>
        </template>
      </el-select>
    </el-form-item>
  </el-col>
  <el-col v-if="isService" :span="24">
    <el-form-item :label="$root.isSmallDevice ? `項目網址: ${productBaseBookingUrl}` : `項目網址`" prop="alias">
      <el-input v-model="submitData.alias" placeholder="請使用英文字母與數字組合">
        <template v-if="!$root.isSmallDevice" v-slot:prepend>{{ productBaseBookingUrl }}</template>
      </el-input>
    </el-form-item>
  </el-col>
</template> -->